import Footer from "../components/Footer";
import Sidebar from "../components/Sidebar";
import { NavLink, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import axios from "axios";
import { useEffect, useState } from "react";
import "../index.css";

export default function ViewPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const url = `${process.env.REACT_APP_API_ROOT}/posts?slug=${slug}`;
        const response = await axios.get(url);
        setPost(response.data[0]);
      } catch (error) {
        console.error("Error fetching post:", error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  if (loading) {
    return <div className="text-center py-10">Loading...</div>;
  }

  if (!post) {
    return (
      <div className="text-center py-10 text-red-600">Post not found.</div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{post.title.rendered}</title>
        <meta name="description" content={post.excerpt.rendered} />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            mainEntityOfPage: {
              "@type": "WebPage",
              "@id": window.location.href,
            },
            headline: post.title.rendered.replace(/(<([^>]+)>)/gi, ""),
            description: post.excerpt.rendered.replace(/(<([^>]+)>)/gi, ""),
            image:
              post.featured_src["0"] ||
              "https://publicspeakingacademy.com.sg/images/psalogo.png", // Replace or map properly
            author: {
              "@type": "Person",
              name: post.author_name || "Admin",
            },
            publisher: {
              "@type": "Organization",
              name: "Public Speaking Academy",
              logo: {
                "@type": "ImageObject",
                url: "https://publicspeakingacademy.com.sg/images/psalogo.png",
              },
            },
            datePublished: post.date,
            dateModified: post.modified || post.date,
          })}
        </script>
      </Helmet>

      {/* BREADCRUMB */}
      <nav
        aria-label="Breadcrumb"
        id="breadcrumb"
        className="bg-[#F5F5FC] py-2"
      >
        <div className="container mx-auto px-3 flex justify-between">
          <h2 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
          <div className="text-sm text-gray-600">
            <NavLink to="/" className="hover:underline">
              Home
            </NavLink>{" "}
            /{" "}
            <NavLink to="/blog" className="hover:underline">
              Blog
            </NavLink>
          </div>
        </div>
      </nav>

      {/* MAIN BLOG POST */}
      <main className="container mx-auto py-20 px-3">
        <article className="flex flex-col lg:flex-row gap-10">
          <div className="w-full lg:w-2/3">
            <header className="mb-5 text-center">
              <h1
                className="text-4xl font-bold text-primary"
                dangerouslySetInnerHTML={{ __html: post.title.rendered }}
              />
            </header>
            <section
              className="prose max-w-none blog-content"
              dangerouslySetInnerHTML={{ __html: post.content.rendered }}
            />
          </div>
          <aside className="hidden lg:block lg:w-1/3">
            <div className="px-5 pt-5 border border-dashed rounded-lg">
              <Sidebar />
            </div>
          </aside>
        </article>
      </main>

      <Footer />
    </>
  );
}
